import React from 'react';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
        paddingTop: '56.25%', /* 16:9 Aspect Ratio */
    },
    responsiveIframe: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        width: '100%',
        height: '100%',
        border: 'none',
    }
  }));

const Map = () => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <iframe src="https://integratedservices.amr.net/gmo/" className={classes.responsiveIframe} />
        </div>
    )
}

export default Map;
